import { render, staticRenderFns } from "./CompProfileEditHouseWork.vue?vue&type=template&id=19464f49&scoped=true"
import script from "./CompProfileEditHouseWork.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditHouseWork.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19464f49",
  null
  
)

export default component.exports